import { z } from 'zod';
import {
  NumericComparator,
  DateComparator,
  GeoLocationComparator,
  ListComparator,
  ObjectComparator,
  BrandAffinityComparator,
  IsOneOfComparator,
  CampaignLabelsComparator,
  CampaignComparator,
  MessageTypeComparator,
  RegexComparator,
  DefaultComparator,
} from '../../types';

export const comparatorSchema = z.union([
  z.nativeEnum(NumericComparator),
  z.nativeEnum(DateComparator),
  z.nativeEnum(GeoLocationComparator),
  z.nativeEnum(ListComparator),
  z.nativeEnum(ObjectComparator),
  z.nativeEnum(BrandAffinityComparator),
  z.nativeEnum(IsOneOfComparator),
  z.nativeEnum(CampaignLabelsComparator),
  z.nativeEnum(CampaignComparator),
  z.nativeEnum(MessageTypeComparator),
  z.nativeEnum(RegexComparator),
  z.nativeEnum(DefaultComparator),
]);
